module.exports = __webpack_public_path__ + "48b25c2b19bb93a86d9cc9368697af02.svg";